import React, { memo, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';

import { actionCreators as i18nActions } from 'react/api/actions/i18n';
import { actionCreators as passwordPoliciesActions } from 'react/api/actions/passwordPolicies';

function PasswordValidator({
  user,
  newPass,
  allHintsValidated,
  maxPerCol
}) {
  const dispatch = useDispatch();
  const i18n = useSelector((state) => state.i18n.get('resources'));
  const policies = useSelector((state) => state.passwordPolicies.get('policies'));

  const validateInputByPolicy = (policy) => new RegExp(policy.get('rule')).test(newPass);

  const allPoliciesValidated = useMemo(
    () => policies.every((policy) => validateInputByPolicy(policy)),
    [policies, newPass]
  );

  useEffect(() => {
    allHintsValidated(allPoliciesValidated);
  }, [allHintsValidated, allPoliciesValidated]);

  useEffect(() => {
    dispatch(passwordPoliciesActions.fetchPolicies(user));
    dispatch(i18nActions.fetchResourcesByKey([
      'PasswordPolicy.Hint.MinimumLength',
      'PasswordPolicy.Hint.LowerCaseCharacters',
      'PasswordPolicy.Hint.UpperCaseCharacters',
      'PasswordPolicy.Hint.MustHaveNumber',
      'PasswordPolicy.Hint.MustHaveNonAlphanumeric',
      'PasswordPolicy.error.foundInHistory',
      'PasswordPolicy.error.notNecessaryDifferentChars'
    ]));
  }, [user, passwordPoliciesActions, i18nActions]);

  if (!policies.size) return null;

  return (
    <div className="passwordHints">
      <ul>
        {policies.map((policy, index) => (
          (index < maxPerCol) ? (
            <li
              className={validateInputByPolicy(policy) ? 'hintValid' : ''}
              key={uuid()}
            >
              {' '}
              {
              Monet.I18n.replaceParamsInResource(
                i18n.get(policy.get('resource')),
                policy.get('rule').replace(/\D/g, '')
              )
            }
            </li>
          ) : null
        ))}
        {policies.map((policy, index) => (
          (index >= maxPerCol) ? (
            <li
              className={validateInputByPolicy(policy) ? 'hintValid' : ''}
              key={uuid()}
            >
              {' '}
              {
              Monet.I18n.replaceParamsInResource(
                i18n.get(policy.get('resource')),
                policy.get('rule').replace(/\D/g, '')
              )
            }
            </li>
          ) : null
        ))}
      </ul>
    </div>
  );
}

PasswordValidator.propTypes = {
  user: PropTypes.string.isRequired,
  newPass: PropTypes.string.isRequired,
  maxPerCol: PropTypes.number.isRequired,
  allHintsValidated: PropTypes.func.isRequired
};

export default memo(PasswordValidator);
